"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDIDDelete = void 0;
const common_1 = require("./common");
function validateDIDDelete(tx) {
    (0, common_1.validateBaseTransaction)(tx);
}
exports.validateDIDDelete = validateDIDDelete;
//# sourceMappingURL=DIDDelete.js.map